import { Checkbox as NulogyCheckbox } from "@nulogy/components";
import { useField, useFormikContext } from "formik";
import React from "react";

export default function Checkbox({ labelText, field: name, onChange, ...props }) {
  const { setFieldValue } = useFormikContext();
  const [field, meta, helpers] = useField(name);

  const handleChange = (event) => {
    const { checked } = event.target;
    if (onChange) {
      onChange({ checked, setFieldValue });
    }
    helpers.setValue(checked);
  };

  return (
    <NulogyCheckbox checked={field.value} error={meta.error} labelText={labelText} onChange={handleChange} {...props} />
  );
}
